<template>
  <div class="p-5 text-center" v-if="job">
    <div v-if="typeOrigin == 'student'">
      <div style="background: #192c51;">
        <br>
          <p style="color:#fff;">El motivo de este mensaje es por que tenemos un lugar en nuestro equipo perfecto para ti: <br> <b style="color:#ed8f00;">{{data.title}}</b> <br>
           Da clic en el siguiente enlace para ver la información completa de la vacante :  <b style="color:#ed8f00;"><router-link :to="'/ver/empleo/' + job.url_public" style="color:#ed8f00;">Ver información</router-link></b> 
          </p>
        <br> 
      </div>
      <br>
      <!-- <h3 class="font-gray-dark fas fa-check"></h3> -->
      La empresa: <strong>{{job.enterprise_min.name}}</strong> esta intentando ponerse en contacto contigo. <br>
      para recibir mensajes es necesario que aceptes la petición. <br>
      <!-- <div class="subject card p-3 my-3">
        Motivo de mensaje <br>
        {{data.title}}
        <router-link :to="'/ver/empleo/' + job.url_public">Ver información
        </router-link>
      </div> -->
      <br><br>
      <b-button class="b-blue shadow" @click="confirm(true)" :disabled="loading">
        Aceptar
      </b-button>
      <b-button class="b-red shadow" @click="remove" :disabled="loading">
        <b-spinner v-if="loading.decline" small label="Espere ..."></b-spinner>
        Rechazar
      </b-button>
    </div>
    <div v-if="typeOrigin == 'enterprise'" class="text-center font-gray-dark">
		<h3 class="fa fa-comments" aria-hidden="true"></h3>
		<br>
		Esperando que candidato acepte petición de contacto
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      job: Object,
      user: Object,
      data: Object
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      typeOrigin: function () {
        return this.$store.getters.typeOrigin
      }
    },
    methods: {
      confirm(status) {
        let form = {
          conversation_id: this.data.id,
          status: status ? 1 : 0
        }
        this.loading = true
        this.api.get('conversation/confirm', form).then(({data}) => {
          this.bus.$emit("confirm", data);
          this.loading = false
        })
      },
      remove() {
        this.loading = true
        this.api.delete('conversation?decline=true&conversation_id=' + this.data.id).then(({data}) => {
          this.$router.push('/perfil/mensajes')
          this.loading = false
        })
      }

    }

  }
</script>



// WEBPACK FOOTER //
// src/components/#pages/messages/components/ConfirmMessage.vue